import { Button, cn } from "kz-ui-sdk";
import { useTranslation } from "react-i18next";
import styles from "../SkinnerBoxFAB.module.css";
import { motion } from "framer-motion";
import { bonusTextVariants, claimButtonLightVariants } from "../utils/animations";
import { INTERACTION_STATE, SKINNER_BOX_STATE } from "../utils/constants";
import { useEffect, useState } from "react";

interface SkinnerBoxActionsProps {
  showClaim: boolean;
  onClaimClick: () => void;
  isLoading?: boolean;
  zIndex: number;
  isBonusActivated?: boolean;
}

const SkinnerBoxActions = ({
  showClaim,
  onClaimClick,
  isLoading = false,
  zIndex,
  isBonusActivated = false,
}: SkinnerBoxActionsProps) => {
  const { t } = useTranslation();

  const [bonusAnimState, setBonusAnimState] = useState<INTERACTION_STATE>(INTERACTION_STATE.IDLE);

  useEffect(() => {
    if (isBonusActivated) {
      setBonusAnimState(INTERACTION_STATE.CLICKED);
      const timer = setTimeout(() => {
        setBonusAnimState(INTERACTION_STATE.HIDDEN);
      }, 1500);
      return () => clearTimeout(timer);
    }
  }, [isBonusActivated]);

  if (!showClaim) {
    return (

      <div
        className="absolute left-0 right-0 flex justify-center"
        style={{ bottom: "27px", zIndex }}
      >
        <motion.div
          className={cn(
            "pointer-events-none inline-block text-center",
            styles.bonusText,
          )}
          variants={bonusTextVariants}
          animate={bonusAnimState}
          initial={INTERACTION_STATE.IDLE}
        >
          {t("bonus")}
        </motion.div>
      </div>

    );
  }

  return (
    <div
      className="absolute left-1/2 -translate-x-1/2"
      style={{ bottom: "16px", zIndex }}
    >
      <motion.span
        variants={claimButtonLightVariants}
        animate={SKINNER_BOX_STATE.CLAIMABLE}
        initial={SKINNER_BOX_STATE.CLAIMABLE}
        className="relative ml-1 inline-block">
        <Button
          size="sm"
          variant="primary"
          className="px-3 py-0"
          shiny
          aria-label="Claim Skinner Box"
          onClick={(e) => {
            e.stopPropagation();
            onClaimClick();
          }}
          loading={isLoading}
          classes={{
            "root&": "min-w-[70px] disabled:!bg-grdPrimary disabled:!opacity-100",
            "label&": "text-[14px] leading-[14px] whitespace-nowrap uppercase",
          }}
          style={{
            paddingTop: 0,
            paddingBottom: 0,
            height: 22,
          }}
        >
          {t("prizes claim")}
        </Button>
      </motion.span>
    </div>
  );
};

export default SkinnerBoxActions;
